import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import CourseSidebar from './components/CourseSidebar';
import CourseItemGrid from './components/CourseItemsGrid';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/course.js';

class CourseGrid extends Component {
    constructor(props) {
        super(props);
        this.state={
            filter:"",
            active:false
        }
        this.changeFilter = this.changeFilter.bind(this)
        this.deactivateFilter = this.deactivateFilter.bind(this)
    }
    changeFilter(e){
        console.log("change filter", e)
            this.setState({
                filter:e,
                active:true
            })
    }
    deactivateFilter(){
        console.log(" filter off")
        this.setState({
            active:false
        })
    }

    render() {
        return (
            <div className="main-wrapper course-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcroumb */}
                <BreadcrumbBox title="Cursos" />

                <Styles>
                    {/* Course Grid */}
                    <section className="course-grid-area">
                        <Container>
                            <Row>
                                <Col lg="3" md="4" sm="5">
                                    <CourseSidebar changeFilter={this.changeFilter} deactivateFilter={this.deactivateFilter} />
                                </Col>
                                <Col lg="9" md="8" sm="7">
                                    <div className="course-items">
                                        <Row>
                                            <CourseItemGrid filter={this.state.filter} active={this.state.active}/>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </Styles>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        )
    }
}

export default CourseGrid